<template>
    <div class="followed-container">
        <div class="column is-12 action-box">
            <div class="field is-grouped is-grouped-right is-flex-wrap">
                <p class="control">
                    <button class="button is-default" @click="addReview" >Add Review</button>
                </p>
            </div>
        </div>
    <o-table
        :data="reviewData"
        :bordered="table.bordered"
        :striped="table.striped"
        :narrowed="table.narrowed"
        :checkable="false"
        :loading="table.loading"
        :mobile-cards="table.mobileCards"
        :paginated="table.paginated"
        :per-page="table.perPage"
        :pagination-simple="table.paginationSimple"
        :selected.sync="selected"
        :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"
    >
        <template>

            <o-table-column #default="{ row }" field="date" label="Date" sortable>
                {{ $filters.date(row.date) }}
            </o-table-column>
            <o-table-column #default="{ row }" field="period" label="Review Period" sortable>
                {{ $filters.date(row.period) }}
            </o-table-column>
            <o-table-column #default="{ row }" field="reviewer" label="Reviewer" sortable>
                {{ row.reviewer.full_name }}
            </o-table-column>

            <o-table-column #default="{ row }" field="efficency" label="EF Rating" sortable>
              {{ row.rating }}%
            </o-table-column>
        
            <o-table-column #default="{ row }" field="comments" label="Comments" sortable>
                {{ row.comments }}
            </o-table-column>
            <o-table-column #default="{ row }" label="">
                <o-dropdown hoverable position="bottom-left" class="table-actions">
                  <template #trigger>
                    <button class="button">
                      <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                    </button>
                  </template>
                    <o-dropdown-item has-link>
                        <a @click="openReview(row)" class="button is-default is-small">View</a>
                    </o-dropdown-item>
                    <!-- <o-dropdown-item has-link>
                        <router-link :to="{ name: 'projects.show', params: { slug: row.id } }" class="button is-default is-small">Download</router-link>
                    </o-dropdown-item> -->
                </o-dropdown>
            </o-table-column>

        </template>

        <template #empty>
            <div class="has-text-centered">
                This table is empty!
            </div>
        </template>
    </o-table>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Table from '../../../mixins/Table'
    import CreateReview from '../../../components/modals/CreateReview'
    import StarRating from 'vue-star-rating'


    export default {
        mixins: [Table],
        components: {
         StarRating   
        },

        props: ['userId', 'user', 'period', 'efRating'],

        data() {
            return {
                reviewData: [],
                followedFrequency: 'weekly'
            }
        },

        mounted() {
            this.loadReviewData()
        },

        methods: {
            ...mapActions([
                'updateFollowedProject',
                'updateFollowedFrequency',
                'getUserReviews'
            ]),
            loadReviewData() {
                this.getUserReviews(this.user).then(p => this.reviewData = p.data.data)
            },

            unfollow (project) {
                this.updateFollowedProject(project).then(res => {
                    this.successMessage('You are not following this project anymore')
                })
            },

            follow (project) {
                this.updateFollowedProject(project).then(res => {
                    this.successMessage('Project has been followed')
                })
            },
            addReview() {
              this.$oruga.modal.open(
                    {
                        component: CreateReview,
                        hasModalCard: true,
                        trapFocus: true,
                        props: { user_id: this.user.id, period: this.period.format('YYYY-MM-DD'), efRating: this.efRating , previousItem: this.reviewData ? this.reviewData[0] : null},
                        events: { modalButtonClick: (e) => this.loadReviewData() }
                    }
                )
            },
            openReview(item) {
              this.$oruga.modal.open(
                    {
                        component: CreateReview,
                        hasModalCard: true,
                        trapFocus: true,
                        props: { user_id: this.user.id, item: item, efRating: this.efRating},
                        //events: { modalButtonClick: (e) => resolve(e) }
                    }
                )
            }
            
        },

        computed: {
            ...mapGetters([
                'followedProjectsByUserId',
                'currentUserId',
                'isFollowed',
                'updateFrequency'
            ])
        }
    }
</script>


<style>
.followed-container select { width: 200px; }

</style>
